export const setLocal = (key, value) => {
  if (typeof window != 'undefined') {
    const item = sessionStorage.setItem(key, value)
    return item
  }
}

export const getLocal = (key) => {
  if (typeof window != 'undefined') {
    const item = sessionStorage.getItem(key)
    return item
  }
}

export const removeLocal = (key) => {
  if (typeof window != 'undefined') {
    const item = sessionStorage.removeItem(key)
    return item
  }
}

// export const isAuthToken = sessionStorage.getItem('authToken') ? true : false
export const isAuthToken = sessionStorage.getItem('authToken') ? true : false

export const clearLocalStorage = () => {
  sessionStorage.clear()
  removeLocal('persist:userInfo')
}

export const getAuthToken = () => sessionStorage.getItem('authToken')
